import React, { useState, useEffect } from 'react';
import { PostDataAPI } from './services/PostDataAPI';
import Header from './components/header';
import Footer from './components/footer';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, Typography, Box, Button, Divider } from '@mui/material';
import { useParams } from "react-router-dom";
import { faAngleDoubleLeft, faAngleDoubleRight } from '@fortawesome/free-solid-svg-icons';

import { useNavigate } from 'react-router-dom';
import SEOTags from './common/SEO';
const NewsDetails = ({ ...props }) => {
    const { slug } = useParams();
    const location = useLocation();
    const newsItem = location.state?.newsItem;

    useEffect(()=> {
        debugger
        console.log(newsItem);
    }, [])

    const _baseURL = process.env.REACT_APP_BASE_URL;
    const { id } = useParams();
    const [newsDetails, setNewsDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const fetchNews = async () => {
        setLoading(true);
        try {
            const result = await PostDataAPI("news/getNewsDetails", id);
            if (result.success && result.data) {
                setNewsDetails(result.data);
                SEOTags(
                    result.data.title,
                    result.data.metaDescription,
                    result.data.metaTitle,
                    _baseURL + result.data.newsPhotoPath,
                    _baseURL + '/#/' + result.data.slug
                );
            } else {
                setError(result.message || "No news available.");
                navigate('/not-found')
            }
        } catch (error) {
            if (error.name !== 'AbortError') {
                setError("Failed to fetch news: " + error.message);
            }
        } finally {
            setLoading(false);
        }
    };
    const [newNewsId, setNewNewsId] = useState(null);
    const openNews = (id) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        navigate(`/news/${id}`);
        setNewNewsId(id);
        setNewsDetails(true);
        fetchNews();
    }
    const shareUrl = window.location.href; // Current page URL
    const title = newsDetails.title || "Check out this news!";
    const formatDate = (dateString) => {
        if (dateString === "0001-01-01T00:00:00" || !dateString) {
            return "";
        }
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    };

    useEffect(() => {
        fetchNews();

    }, [id]);
    return (
        <>

            <Header />
            <section
                style={{
                    backgroundImage: `linear-gradient(rgb(0 0 0 / 93%), rgb(0 0 0 / 83%)), url(${"/" + newsItem?.bannerPath})`,
                    backgroundSize: "cover",
                    backgroundPosition: "right",
                }}
                className="sub-hero pa-hero">
                <div className="container">

                    <h1>{newsItem?.title}</h1>

                    <p>
                        {newsItem?.shortDescription}
                    </p>
                    <div
                        style={{
                            marginTop: "20px",
                            display: "flex",
                            gap: "12px",
                            flexWrap: "wrap",
                        }}
                    >
                        {/* <Link to={'/contact-us'} className="btn-gold">
                            Free Consultation
                        </Link>

                        <a href="tel:+8556435291" className="btn-outline-ivory">
                            Call (855) 643-5291
                        </a> */}
                    </div>
                </div>
            </section>

            <section className="about" id="about">
                <div className="container">
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12}>
                            <div className={'news-detail-container'}>

                                <img
                                    src={"/" + newsItem?.bannerPath}
                                    style={{ width: "100%" }}
                                />

                                {/* <Grid row>
                                    <Grid container>
                                        <Grid item xs={12} sm={6} lg={6}>
                                            <span className={'auther_details'}>Cateogry: {newsItem.category}</span>
                                        </Grid>

                                    </Grid>
                                </Grid> */}



                                <div className='news-content'>
                                    <Typography variant="h5" component="h2" gutterBottom sx={{ mt: 3 }}>
                                        {newsDetails?.title}

                                    </Typography>


                                    <div style={{ padding: '10px 0' }} dangerouslySetInnerHTML={{ __html: newsItem?.longDescription }}></div>
                                </div>




                            </div>
                        </Grid>

                    </Grid>
                </div>


            </section>


            <Footer></Footer>
        </>
    );
};

export default NewsDetails;
